import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpeedometerComponent } from './speedometer.component';
import { SpeedometerRenderColorPipe } from './speedometer-render-color.pipe';

@NgModule({
  declarations: [SpeedometerComponent, SpeedometerRenderColorPipe],
  exports: [SpeedometerComponent],
  imports: [
    CommonModule
  ]
})
export class SpeedometerModule { }
